import { render, staticRenderFns } from "./FeedbackAnalyticsTableCellRendererType.vue?vue&type=template&id=590a270f&"
import script from "./FeedbackAnalyticsTableCellRendererType.vue?vue&type=script&lang=js&"
export * from "./FeedbackAnalyticsTableCellRendererType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports